import {
    AUTHENTICATE_ZOHO_REQUEST, AUTHTENTICATING_ZOHO_SUCCEEDED, AUTHTENTICATING_ZOHO_FAILED,
    UPDATE_ZOHO_REQUEST, UPDATING_ZOHO_SUCCEEDED, UPDATING_ZOHO_FAILED
  } from 'constants/actionTypes';
  
  import axios from 'axios';
  import { createAction } from 'redux-actions';
  import buildUrl from 'build-url';
  import { call, put, takeEvery } from 'redux-saga/effects';
  
  const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
  const ZOHO_BASE_URL = `${apiUrl}/integrations/zoho`;
  
  /*
  * Authenticate Zoho
  */
  export const authenticateZoho = createAction(AUTHENTICATE_ZOHO_REQUEST, (code, location, callback) => {
    return {
      code: code,
      location: location,
      callback: callback
    }
  })
  
  const authenticateZohoSucceeded = createAction(AUTHTENTICATING_ZOHO_SUCCEEDED, (response) => {
    return response;
  })
  
  const authenticateZohoFailed = createAction(AUTHTENTICATING_ZOHO_FAILED, (error) => {
    return error;
  })
  
  function* authenticateZohoSaga(action) {
    const { code, location, callback } = action.payload;
  
    let params = {
      code: code,
      location: location
    }
  
    let url = buildUrl(ZOHO_BASE_URL, {
      queryParams: params
    });
  
    const authenticateZohoAPI = () => {
      return axios.post(url).then(response => response.data);
    }
  
    try {
      const response = yield call(authenticateZohoAPI);
      if (response) {
        yield put(authenticateZohoSucceeded(response));
      }
      if (callback) {
        callback(response);
      }
    } catch (error) {
      yield put(authenticateZohoFailed(error));
    }
  }
  
  /*
  * Update Zoho
  */
  export const updateZoho = createAction(UPDATE_ZOHO_REQUEST, (request, callback) => {
    return {
      request: request,
      callback: callback
    };
  })
  
  export const updatingZohoSucceeded = createAction(UPDATING_ZOHO_SUCCEEDED, (response) => {
    return response;
  })
  
  export const updatingZohoFailed = createAction(UPDATING_ZOHO_FAILED, (error) => {
    return error;
  })
  
  function* updateZohoSaga(action) {
    const { request, callback } = action.payload;
  
    const updateZohoAPI = () => {
      return axios.put(ZOHO_BASE_URL, request).then(response => response.data);
    }
  
    try {
      const response = yield call(updateZohoAPI);
      if (response) {
        yield put(updatingZohoSucceeded(response));
      }
      if (callback) {
        callback(response);
      }
    } catch (error) {
      yield put(updatingZohoFailed(error));
    }
  }

  
  export default function* zohoSaga() {
    yield takeEvery(AUTHENTICATE_ZOHO_REQUEST, authenticateZohoSaga);
    yield takeEvery(UPDATE_ZOHO_REQUEST, updateZohoSaga);
  }